<template>
  <a-modal
    :visible="visible"
    :width="1000"
    style="top:30px;"
    title="易仓科技平台注册及软件普通许可使用协议"
    @ok="handleOk"
    @cancel="handleOk"
    destroyOnClose
  >
    <template slot="default">
      <div class="content">
        生效日期：本协议最后更新时间为2025年01月01日，<span class="border_red color_red">在您接受本协议之日起，本协议即在您与我们之间生效。</span><br>
        重要提示：客户在注册成为易仓科技官网平台用户及购买软件普通许可使用服务、使用易仓科技软件前，<span class="border_red color_red">请认真阅读本协议全部内
        容，在本协议中加粗、下划线、标红，等方式显著标识的文字、特别与您权利义务相关或限制您权利义务相关约定，请着重阅读，慎重考虑</span>。<br>
        本易仓科技平台注册及软件普通许可使用协议（简称“协议”）适用于同意本协
        议及其附件、同时包含深圳市易仓科技官方网站（网址：<a target="_blank" href="https://www.sellerwell.com/">https://www.sellerwell.com/</a>）（以下
        简称“易仓科技官网平台”）公示的规范、规则、条款、信息（以下简称“相关条款”）约定的企业、自然人、团体、其他组织（以下简称“客户”）对本
        易仓科技软件协议约定的服务（以下简称“服务”）的使用。<span class="color_red">如本协议或上述相关条款有
        更新的，如与原相关条款约定有冲突的，以更新版本约定内容为准。</span><br>
        客户是本协议的一方，另一方为深圳市易仓科技有限公司（以下简称“易仓科技”），易仓科技公司管理易仓科技官网平台及软件相关业务。<br>
        <u>客户在易仓科技官网平台注册成为用户后，负责自行管理该用户帐户，您必须代表客户接受本协议</u><br>

        <u>客户阅读本协议后，如选中复选框“同意”的选项表示您确认已代表客户审阅并订立本协议及其附件，您已获
          授权代表客户接受本协议及其附件、相关条款的约束，即客户已阅读、理解并同意接受本协议，本协议内容
          包括协议正文及易仓科技官网平台所有已经发布或将来可能发布的各类规则、细则、协议等文本，以上内容均为本协
          议不可分割的一部分，与协议正文具有同等法律效力</u>
        <span class="color_red">如果您不具备约束该客户的法定权力或您未取得授权选择注册及购买、使用易仓科技
        官网平台服务的，请不要选中复选框“同意”的选项表示您接受本协议条款。</span><br>

        如客户对协议有任何疑问，应向易仓科技官网平台咨询（咨询联系方式为0755-86528003）。但无论客户事实
        上是否在使用易仓科技官网平台服务之前认真阅读了本协议内容，<u>一经注册即表明客户承诺接受并遵守本
          协议的约定，届时客户不应以未阅读本协议的内容或者未获得平台对客户问询的解答等理由，主张本
          协议无效，或要求撤销本协议。如果客户不同意本协议及相关条款的约定，客户应立即停止以下事宜：注册
          账户、购买软件普通许可使用服务、使用软件及其他事宜。</u>。<br>

        <h3>一、易仓科技官网平台及软件普通许可使用的注册及帐户管理</h3>
        1.客户注册成为易仓科技官网平台用户，向易仓科技提供客户联系方式及易仓科技所需资料，并确认
        接受本协议后，易仓科技将向客户提供访问、使用易仓科技官网及软件帐户。<br>

        如客户需要使用易仓科技软件的，客户需自行在易仓科技官网采购下单相应的软件服务并按时足额付费，否则不能享有软件普通许可的相应服务。<br>
        易仓科技官网平台有不同的软件（以下简称“易仓科技软件”）服务，每款软件服务有不同的套餐，每款套餐有不同的服务内容及软件的普通许可使用权限范围。请客户在下单前仔细阅读所需采购软件服务及套餐内容。<br>

        <u>客户选择所需软件服务套餐进行下单，并依据本协议附件1《付款条款》约定足额按时进行付款，客户付款后，经易仓科技确认无误的，客户可获得已付款订单中相应易仓科技软件的普通许可使用权限，软件普通许可使用范围依据客户付款金额及易仓科技官网对标明对应的软件相关功能、期限、次数等约定。</u><br>

        2.客户确认并承诺其具备中华人民共和国法律规定的与客户行为相适应的民事行为能力。否则，客户承担因此而导致的一切后果。<br>
        客户同意如客户为任何国家、国际组织或者地域实施的贸易限制、制裁或其他法律、规则限制的对象，则客户自行承担
        因无法正常注册及使用易仓科技官网平台服务的相关损失及责任。<br>
        3.易仓科技官网平台帐户说明<br>
        3.1【实名认证】作为易仓科技官网平台经营者，为使客户更好地使用易仓科技官网平台的各项服务，保障客户的帐户安全，<u>易仓科技官网平台有权
          要求客户按易仓科技要求及我国法律规定完成实名认证，并要求客户提供真实、完整、有效的注册登记信息资料。</u><br>

        3.2【唯一帐户】<u>易仓科技官网平台只允许每位用户使用一个易仓科技官网平台帐户。
        客户承诺不存在不当注册或不当使用易仓科技官网平台帐户的情形，</u>，<span class="color_red">否则，易仓科技官网平台可采
        取冻结或关闭帐户、取消客户在易仓科技官网平台上享有的权益、限制客户使用软件相关服务及拒绝为客户提供其他服务等措施，如客户造成
        易仓科技官网平台及第三方损失的，客户还应承担相关损失费用及其他赔偿责任</span><br>

        3.3客户有权使用客户设置或确认的易仓科技官网平台帐户及密码登录易仓科技官网平台。<u>客户的易仓科技官网平台帐户仅限客户使用。</u>。
        <span class="color_red">客户直接或间接授权第三方使用客户易仓科技官网平台帐户或获取客户帐户项下信息、资产的行为无效。如
        客户违约授权第三方适用帐户可能危及客户的帐户安全及或易仓科技官网平台信息安全的，易仓科技官网平台可拒绝提供相应服务或终止本协议</span><br>

        3.4【帐户转让】<u>客户同意仅当有法律法规规定、司法裁定或经易仓科技官网平台书面同意的，客户才可以
        进行帐户的转让，且该帐户项下权利义务一并转移</u>。<span class="color_red">此外，客户的帐户不得以任何方式转让，否则易仓科技官
        网平台有权追究客户的违约责任，易仓科技官网平台可拒绝提供相应服务或终止本协议，且由此产生的一切责任均由客户承担</span>。<br>

        3.5【主体变更】客户不得随意更改客户作为注册帐户主体。如因客户业务调整需更换公司、团体或其他主体，客户应重新提交相
        关资料，经易仓科技官网平台审核通过后，客户才可以更改相关资料，如企业名称、企业logo、企业相关业务等。<br>

        如客户未获得易仓科技官网平台同意自行更改注册主体的，或经易仓科技官网平台同意更改但客户未能提供真实、有效、完整的资料的，易仓科技
        官网平台将暂停为客户提供服务，且客户经易仓科技官网平台通知后客户仍不整改的，易仓科技官网平台有权对客户或客户更改后的帐户予以
        注销，由此产生的客户或第三方或易仓科技官网平台的责任及损失均由客户自行承担。<br>

        3.6【人员对接】客户自注册易仓科技官网平台帐户之日起，应委派客户工作人员与易仓科技官网平台人员对接相关工作，如客户
        委派的工作人员变更的，客户应提前五个工作日书面告知易仓科技官网平台新对接人员联系方式，<span class="color_red">如客户未告知易
        仓官网平台上述事项或客户因此造成帐户管理不善的，相关责任及费用由客户自行承担，如易仓科技官网平台发现客户存在上
        述事项的，有权通知客户整改，由此产生的客户或第三方或易仓科技官网平台的责任及损失均由客户自行承担</span>。<br>

        3.7【更新维护】客户应当及时更新客户提供的信息，<u>易仓科技官网平台根据法律法规规定对客户提
        供的信息进行核实以及维护平台安全的情况下，有权对客户的信息进行检查核实，客户应当配合易仓科技官
        网平台不断更新、提供真实、完整、有效的客户及其相关信息</u>。<br>

        <span class="color_red">如客户未按易仓科技官网平台的要求及时提供信息、或信息存在明显不实或行政司
        法机关核实客户提供的信息无效的，客户将承担因此对客户自身、他人及易仓科技官网平台造成的全部损失与责任。易仓科技官
        网平台有权终止对客户提供部分或全部易仓科技官网平台服务，易仓科技官网平台对此不承担责任</span>。<br>

        4.帐户安全保管<br>
        4.1【帐户安全】<u>客户务必保管好客户的帐户</u>。<span class="color_red">帐户因客户主动泄露或因客户
        遭受第三方导致的损失及后果，客户应自行通过司法行政等途径向侵权行为人追偿，易仓科技官网平台不承担责任及损失
        赔偿。同时，客户应立即通知易仓科技官网平台，并授权易仓科技官网平台冻结客户帐户。易仓科技官网平台应客户请求而采取的行动
        可能无法避免或有效阻止侵权情况，据此，易仓科技官网平台不承担责任及损失费用</span>。<br>
        4.2【责任承担】<u>客户对帐户项下的所有行为结果负责并承担相应的后果。</u><br>

        <h3>二、付款</h3>
        1.客户可通过易仓科技官网平台提示选择付款方式或易仓科技官网接受的其他付款方式付款。本协议项下的所有
        付款均受在平台上发布的届时有效的有关付款的条款和条件约束。<u>付款及税费相关事项
        详见附件1《付款条款》及客户下单后系统所自动生成的订单。</u><br>

        2.税款<br>
        如依据法律规定客户需要开具发票的，则客户必须向易仓科技提供正式适当的凭证证明该等已付款项及开票信息。<br>

        <h3>三、易仓科技软件使用功能</h3>
        本协议项下易仓科技软件使用功能均受在易仓科技官网平台上发布的届时有效的有关软件功能的条款和
        条件约束。<span class="color_red">客户在签订本协议时应自行阅读软件功能，客户选中复选框“同意”的选项表
          示您接受本协议条款并知悉软件功能、您应支付的相关费用</span>。<br>

        <h3>四、客户权利与义务</h3>
        1.<u>客户有权在易仓科技官网平台上依据法律法规及易仓科技官网平台服务规则、经按时足额付费后，在易仓科技普通许可使用范围内使用客户所订购的易仓科技软件</u>。<br>
        2.<u>客户不得在易仓科技官网平台从事以下事项：</u><br>
        <u>（一）法律法规规定禁止或限制的事项；</u><br>
        <u>（二）侵犯他人知识产权事项；</u><br>
        <u>（三）侵犯其它合法权益的事项；</u><br>
        <u>（四）易仓科技官网平台规则、公告、通知或易仓科技官网平台与客户单独签署的协议中已明确说明不适合在易仓科技官网平台、或不适宜使用易仓科技软件从事的事项。</u><br>
        3.客户应当遵守公序良俗、诚实信用原则、法律法规规定使用易仓科技软件。<br>
        4.客户不得从事侵犯或干扰易仓科技官网平台运作、易仓科技软件系统运行的事项，不得干扰易仓科技官网平台上进行的任何交易、活动。<br>
        5.<span class="color_red">为维护易仓科技官网平台、易仓科技软件系统运行秩序及交易安全，如易仓科技官网平台、软件系统发现客户的任一行为存在扰乱
        易仓科技官网平台正常交易秩序的行为的，或破坏软件系统的，或任一违反法律法规或易仓科技官网平台公示的规则的或本协议及其附件或其他
        双方签署的协议约定事项的，则易仓科技官网平台有权主动执行限制、禁止客户帐户使用等操作，由此产生的责任及费用均有客户自行承担</span>。<br>
        6.<u>客户同意不时地阅读易仓科技官网平台更新地规则、协议、文件、版块规定等事项，如相关变更
        事项发布之日起，客户仍使用易仓科技官网平台及/或易仓科技软件的，视为客户同意并接受上述变更事项并受其约束。</u><br>
        7.<span class="color_red">客户同意并理解，如因使用易仓科技软件系统发生遗失、被盗、被误用或被擅自修改、计算机设备故障、操作失误、客户与第三方之间的损失赔偿等情况造成的损失的，均由客户自行承担担</span>。<br>

        <h3>五、易仓科技官网平台的权利与义务</h3>
        1.易仓科技官网平台有权禁止客户在易仓科技官网平台或易仓科技软件上从事违反本协议或易仓科技官网平台更新地规则、协议、文件、版块规定等事项；<br>
        2.<u>如果客户违反法律法规或本协议约定或易仓科技官网平台规则的，易仓科技官网平台有权停止为客户提供服务；</u><br>
        3.<span class="color_red">如客户使用所采购的易仓科技软件普通许可使用期限及服务到期之日起1个月内，客户未再足额续费的，自满一
        个月（按连续30个自然日计算）的当日系统内将自动清空客户此前使用软件系统的所有业务数据。若清空后客户再次
        续费的，将不恢复客户此前使用软件系统所产生的所有历史数据。如客户未续费或存在其他违反本协议、或易仓科技官网平台更新地
        规则、协议、文件、版块规定等事项的，易仓科技官网平台享有注销客户帐号、终止客户使用的权限；</span><br>
        4.易仓科技官网平台有依据本协议及网站（网址：易仓科技官网）公布的信息为客户提供指导客户使用易仓科技软件的相关功能；<br>
        5.易仓科技官网平台有权按本协议及易仓科技官网平台规则向客户收取费用；<br>
        6.易仓科技依据本协议、法律法规赋予的权利义务监督管理易仓科技官网平台及易仓科技软件。<br>
        <h3>六、支持和维护</h3>
        易仓科技官网平台将根据公布在易仓科技官网网站上的、适用于易仓科技软件所有版本支持的、届时有效的条款和条件向客户提供软件使用及维护支持。<br>
        <h3>七、内容安全</h3>
        1.易仓科技官网平台承诺尽量实施相关技术措施防止存储在易仓科技软件上的内容意
        外丢失和遭未经授权的访问和使用。除外情况：<span class="color_red">如客户自行删除内容或未能保管好
        帐户导致内容泄露或其他非易仓科技官网平台、易仓科技原因导致的内容被删除的，则易仓科技官网平台、易仓科技不承担相关事项及后果。易仓科技
        官网平台、易仓科技并不保证未经授权的第三方将无法获得易仓科技软件的访问权，且客户确认，对于客户及其最终用户存储在易仓科技软件
        中的所有内容，由客户及其最终用户自行承担风险</span>。<br>
        2.<u>客户同意负责确保已经备份其内容，以防存储在易仓科技软件中的内容发生任何丢失情况</u>。
        <h3>八、隐私</h3>
        具体详见易仓科技官网平台公布的隐私政策。<br>
        <h3>九、保密</h3>
        1.除依照本协议规定及隐私条款所述而提供易仓科技软件服务需要，易仓科技可访问、披露和
        共享客户及其最终用户的该等保密信息的情形外，双方承诺不会向任何第三方透露任何
        从另一方获得的明示为专有或保密或者根据其性质明显应被视为保密或专有的信息（简称“保密信息”）。<br>
        2.以下事宜不属于保密信息，双方均不负有保密义务：<br>
        2.1接收人表明以本协议所规定之外的方式获取或者从另一方获取之前，接收人已经知悉的信息；<br>
        2.2已经在公共领域公开的信息。<br>
        2.3依据本协议，或法律法规规定，或司法机关决定，或政府机构要求，或第三方的合法请求而使该方确定有必要披露保密信息。<br>
        <h3>十、公开</h3>
        <span class="color_red border_red">客户同意易仓科技在易仓科技官网平台网站和市场营销材料中提及客户。</span><br>
        <h3>十一、订立合同及履约保证</h3>
        1.双方均向对方声明并保证，其签订本协议符合各自内部签订协议的，可签订本协议并按照本协议条款履行义务。<br>
        2.<span class="color_red border_red">客户进一步声明，其在易仓科技官网平台注册及使用易仓科技软件并接受本协议的自然人已得到客户授权代表客户从事上述相关操作。</span><br>
        <h3>十二、违约责任</h3>
        1.<u>对于客户因违反本协议约定或违反法律法规规定或客户未付费导致本协议和/或终止或不续约而引起或因第三
        方原因导致的相关的任何损失、责任损害，易仓科技官网平台及易仓科技公司均无须对客户或第三方承担任何责任</u>。<br>
        2.<span class="color_red border_red">如需承担损失或责任的，易仓科技官网平台及易仓科技公司在本协议项下的最
        高合计和累计违约金及损害赔偿责任，均不得超出客户提起任何损害赔偿主张之前的3个月内客户根据
        本已向易仓科技官网平台及易仓科技公司支付的费用金额。</span><br>
        3.<span class="color_red border_red">如客户违反本协议及其附件或违反易仓科技官网平台公示的规则
        的或违反法律法规规定的，客户应向易仓科技公司承担违约及赔偿责任。</span><br>

        <h3>十三、许可</h3>
        1.<u>本协议项下客户仅在依据采购订单付费后，在易仓科技公司授权范围内获得套餐对应的订购期内易仓科技软件的普通使用许可，非独占使用许可、非排他使用许可。</u><br>
        2.许可限制<br>
        未经易仓科技公司事先书面许可，客户不得实施以下行为：<br>
        2.1将许可软件向第三方提供、销售、出租、出借、转让或提供分许可、转许可、通过信息网络传播或以其他形式供他人利用。<br>
        2.2制作、指使第三方制作或许可第三方制作许可软件或许可资料的复制品。<br>
        对许可软件进行全部或部分地翻译、分解、反向编译、反汇编、反向工程或其他试图从许可软件导出程序源代码的行为，或在许可软件的基
        础上书写或开发衍生软件、衍生产品或其他软件。<br>
        2.3限制、破坏或绕过许可软件附带的加密附件或易仓科技提供的其他确保许可软件正确使用的限制性措施。<br>
        2.4将许可软件用于除客户使用以外的其他目的，包括但不限于向第三方提供数据处理服务、应用服务、商业共享或其他软件共享安排。
        2.5除掉、掩盖或更改许可软件上有关许可软件著作权或商标的标志。<br>

        <h3>十四、知识产权</h3>
        1.<u>客户承认现有及升级版本许可软件及与许可软件有关的源代码、目标代码、二次开发、改进软件涉及
          的相关事项、文档资料、以及任何由易仓科技根据维护与技术支持提供的软件、资料的著作权及其他知识产权均归易仓科技所有</u>。<br>
        2.<u>易仓科技未向客户授予包括但不限于许可软件相关的著作权、专利权、商标专用权、商业秘密及其他权利有关的任何权利</u>。<br>

        <h3>十五、期限</h3>
        本协议自生效日起生效。客户依据本协议及附件1《付款条款》、客户采购订单约定向易仓科技支付易仓科技软件普通许可使用及服务的相关费用。<br>

        <h3>十六、协议终止</h3>
        1.客户在履行完毕相关权利义务后可随时通过管理控制台终止本协议，<span class="color_red">客户理解并同意易仓科技已给
        予客户优惠，在任何情况下，客户均不要求易仓科技平台退还截至该终止日期时已支付给易仓科技的费用或者减免应付给易仓科技费用</span>。<br>
        2.<span class="color_red">协议终止或解除的，则客户不再享有易仓科技软件的普通许可使用权限及服务</span>。<br>

        <h3>十七、通知</h3>
        1.客户应在注册易仓科技官网平台帐户时提供有效、完整的联系方式。<br>
        2.易仓科技公司联系方式如下：<br>
        送达地址:深圳市南山区留仙大道创智云城A6座；<br>
        电子邮件:ec-mkt@eccang.com；<br>
        联系电话：400-8199-388。<br>
        3.双方根据本协议要求做出或允许做出的任何通知应以书面形式通过专人、电子邮件或快递送达。<br>
        4.通知被视为送达的日期应按如下方法决定：<br>
        a)专人递交的通知在专人递交之时视为有效送达；<br>
        b)以（预付邮资的）挂号信件发出的通知，应在寄出日（以邮戳为准）后第五（5）个工作日视为有效送达；<br>
        c)以快递发送的通知应于交予合法的快递服务发送后第三（3）个工作日视为有效送达；<br>
        任何一方改变其通信地址、收件人及传真号，应及时书面通知另一方。否则，通知方式不视为变更。<br>
        <h3>十八、适用法律及争议解决</h3>
        1.<u>本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律。</u><br>
        2.<u>客户因使用易仓科技官网平台及所产生及易仓科技软件与易仓科技公司有关的争议，由易仓科技公司与客户协商解决。协商不
        成时，任何一方均可向被告所在地有管辖权的人民法院提起诉讼。</u><br>
        3.本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。<br>
        <h3>十九、协议、继受人和受让人</h3>
        除合并、资产出售、企业重组或以其他方式依法进行继受的情形外，未经另一方事先书面同意，任何一方
        不得转让本协议或本协议项下的任何权利或利益，亦不得委托他人履行本协议项下的任何义务。<br>
        <h3>二十、不可抗力</h3>
        因不可抗力原因（包括劳资纠纷、内乱、战争、疫情、政府规定或控制、人员伤亡、无法获得第三方提供
        的材料或服务，或天灾）无法履行本协议的任何条款（现金支付除外），则该违约方将可在延迟期间以及此后合理的时间期限内免于履行条款。<br>
        二十一、放弃及修改
        1.易仓科技公司可随时自行决定修订本协议，且在这种情况下，易仓科技公司将在网站（网址：<a target="_blank" href="https://www.sellerwell.com/">https://www.sellerwell.com/</a>）上发布新版协议（以下简称“修订协议”）。<br>
        2.<span class="color_red">客户在任何更新生效之后继续使用易仓科技软件的，将被视为代表客户同意接受修订协议的条款的约束和同意该等条款</span>。<br>
        3.<span class="color_red">如修订协议对客户的权利或义务的造成任何重大不利变更的，且客户不愿意继续根据经修订协议的条款使用易仓科技软
        件并提出合理依据的，则客户可以与易仓科技公司协商解决上述事宜</span>。<br>
      </div>
    </template>
    <template slot="footer">
      <a-button key="submit" type="primary" @click="handleOk">
        确定
      </a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'AgreementModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleOk () {
      this.$emit('ok')
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.@{ant-prefix}-modal {
  top: 5vh;
   .@{ant-prefix}-btn-primary {
    background: #077BFC;
  }
}
.content {
  margin:0 auto;
  line-height:24px;
  font-size:18px;
  font-weight:400;
  margin-bottom: 17px;
  font-size:14px;
  height: calc(90vh - 180px);
  overflow-x: auto;
  h3 {
    margin-top: 23px;
    margin-bottom: 15px;
    color: #000;
    font-weight: 400;
  }
  .border_red {
    text-decoration: underline;
    text-underline-color: red;
    -moz-text-decoration-color:red;/*针对Firefox的代码*/
  }
  .color_red {
    color:red;
  }
}
</style>
